import { CalendarRange, Headset, ShieldCheck, Wrench } from 'lucide-react';
import { PERKS, type Perk } from '@/data/homeContent';

const ICONS: Record<Perk['icon'], typeof Wrench> = {
  calendar: CalendarRange,
  wrench: Wrench,
  shield: ShieldCheck,
  headset: Headset
};

export const PerksRow = () => (
  <section aria-label="Miért minket válasszon" className="mx-auto w-full max-w-[1220px] px-4 pt-4 sm:px-6">
    <ul className="grid list-none gap-4 p-0 sm:grid-cols-2 lg:grid-cols-4">
      {PERKS.map((perk) => {
        const Icon = ICONS[perk.icon];

        return (
          <li key={perk.title} className="rounded-xl bg-sand-soft p-6">
            <Icon className="size-8 text-teal-ink" aria-hidden="true" />
            <p className="mt-3 font-display text-lg font-bold text-navy">{perk.title}</p>
            <p className="mt-1.5 text-sm text-ink-soft">{perk.description}</p>
          </li>
        );
      })}
    </ul>
  </section>
);
